/**
 * Client mirror of modules/mulliganOpeningGate.js — block End Turn until both
 * PvP players finish opening mulligan.
 */

export function openingMulliganResolvedForPlayer(playerState) {
  return !!playerState && (playerState.needsMulligan !== true || playerState.hasMulliganed === true);
}

export function isPvPTwoPlayerGame(gameState) {
  if (!gameState || !Array.isArray(gameState.players) || gameState.players.length !== 2) {
    return false;
  }
  return !gameState.players.some(
    (p) => p === 'bot' || p === 'campaign_bot' || String(p).startsWith('bot')
  );
}

/**
 * @returns {boolean} true when End Turn / play actions must wait for mulligan
 */
export function shouldBlockForOpeningMulligan(gameState) {
  if (!isPvPTwoPlayerGame(gameState)) {
    return false;
  }
  if (!gameState.state) {
    throw new Error('shouldBlockForOpeningMulligan requires gameState.state');
  }
  const p1 = gameState.state[gameState.players[0]];
  const p2 = gameState.state[gameState.players[1]];
  if (!p1 || !p2) {
    throw new Error('shouldBlockForOpeningMulligan requires both player states');
  }
  return !(openingMulliganResolvedForPlayer(p1) && openingMulliganResolvedForPlayer(p2));
}
